<template>

<div>

    <div id="modal_punch" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Ta ett klipp</h4>
                </div>
                <div class="modal-body">

                    <div class="form-group">
                        <label class="control-label" style="padding-left: 0px;">Datum</label>

                        <datepicker language="sv" :disabled="disabled" v-on:selected="selectDate" :format="date_format"></datepicker>

                    </div>

                    <div class="form-group">
                        <label class="control-label" style="padding-left: 0px;">Massörskod</label>

                        <div class="input-group">
                            <input type="text" class="form-control" style="width: 100%;" v-model="signature_key" />
                        </div>

                    </div>

                    <div class="form-group">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="create_clinic_feedback"> Skicka SMS med enkätlänk.
                            </label>
                        </div>
                    </div>

                    <div class="form-group" v-if="activeCard && activeCard.punchesLeft === 1 && activeCard.affiliate && activeCard.affiliate.send_sms_for_new_cards">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="create_sms_marketing"> Skicka SMS till kund om att klippen är slut i kortet
                            </label>
                        </div>
                    </div>

                    <div class="alert alert-danger" v-if="alerts.error == true">
                        {{ response.errormess }}
                    </div>

                    <div class="alert alert-info" style="line-height: 36px;" v-if="alerts.confirm == true">

                        <span v-if="signature_key.charAt(0).toLowerCase() == 'm'">
                            Bekräfta behandling på: <strong>{{ response.message.name_clinic}}</strong>
                        </span>
                        <span v-else>
                            Bekräfta behandling av: <strong>{{ response.message.name_person }}</strong>
                        </span>
                        <button class="btn btn-default pull-right" v-on:click="punch('confirm')">Bekräfta</button>
                    </div>

                    <div class="alert alert-success" v-if="alerts.complete == true">
                        Behandlingen har registrerats.
                    </div>

                </div>
                <div class="modal-footer">
                    <button class="btn btn-default pull-right" type="button" v-on:click="punch('validate')">Fortsätt</button>
                    <button type="button" class="btn btn-info pull-right" data-dismiss="modal" style="margin-right:10px;">Avbryt</button>
                </div>
            </div>
        </div>
    </div>

</div>

</template>

<script>

/*
    import datepicker from './../datepicker/Datepicker.vue'
    Vue.component('datepicker', datepicker);
    */

import moment from 'moment'

export default {

    props: {
        activeCard: {},
        customer: {},
        inactiveFromPeriod: {}
	    },

	    data: function () {
        return {

            test: {},

            date_format: 'yyyy-MM-dd',

            	signature_key: null,
            treatment_date: null,
            create_clinic_feedback: true,
            create_sms_marketing: true,

            response: null,

            mode: 'validate',

            alerts: {
                error: false,
                confirm: false,
                complete: false
            },

            disabled: {
                to: new Date(this.inactiveFromPeriod.year, this.inactiveFromPeriod.month, 1),
                from: moment().endOf('day').toDate()
            }
        }
    },

	    methods: {

        punch: function (mode) {
            const self = this

            self.mode = mode

            console.log('what is the active card?')
            console.log(self.activeCard)

            const data = {
                card_id: self.activeCard.id,
                signature_key: self.signature_key,
                treatment_date: self.treatment_date,
                create_clinic_feedback: self.create_clinic_feedback,
                create_sms_marketing: self.create_sms_marketing,
                mode: self.mode
            }

            this.$http.post('/cards/punch', data).then((response) => {
                console.log(response.body)

                self.response = response.body

                if (self.response.error == true) {
                    self.alerts.error = true
                    self.alerts.confirm = false
                    self.alerts.complete = false

                    if (self.response.message == 'noClinicPrice') {
                        self.response.errormess = 'Massören saknar ersättningsbelopp'
                    }
                }

                if (self.mode == 'validate' && self.response.error == false) {
                    self.alerts.confirm = true
                    self.alerts.complete = false
                    self.alerts.error = false
                }

                if (self.mode == 'confirm' && self.response.error == false) {
                    self.alerts.confirm = false
                    self.alerts.complete = true

                    bus.$emit('refresh-data', 1)
                    bus.$emit('notify', 'Behandlingen har registrerats.')

                    $('#modal_punch').modal('hide')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        selectDate: function (date) {
            this.treatment_date = date
        }

	    },
    watch: {

    }

}
</script>
